export const CAR_QUALITY_ANIMATION_WRAPPER_ID = 'car-quality-animation-wrapper';

export const CAR_QUALITY_ANIMATION_HEIGHT = 10000;
